function previewdate(date) {
  const d = new Date(date);
  if (typeof d.getMonth === 'function'){
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      
      $outputdate = monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
      
  }
  else $outputdate = date;
  return $outputdate;
}
   
 (function($){
  $(document).ready(function(){	
     $('.box.corners').append('<div class="cornersupport"></div>');
  });
 	
})(jQuery);